jQuery(function ($) {
  const appUrl = window["app_url"];
  const resetPassSuccessMess = $("#reset_pass_success_mess");

  // get OTC form
  const frmLoginWrapper = $('#CustomerLoginForm');
  const frmGetOtcWrapper = $('#RecoverPasswordForm');

  const frmGetOtc = $('#frm_get_otc');
  const frmGetOtcErrorWrapper = frmGetOtc.find('#form-get-otc-error');
  const frmGetOtcErrors = frmGetOtcErrorWrapper.find('.errors');
  const btnGetOtc = frmGetOtc.find('button');
  const btnGetOtcText = btnGetOtc.text();
  let currentGetOtcRequest = null;

  // define from validator
  frmGetOtc.validate({
    rules: {
      "email": {
        required: true,
        email: true
      }
    },
  });

  // reset password form
  const frmResetPassword = $('#frm_reset_password');
  const frmResetPasswordErrorWrapper = frmResetPassword.find('#form-reset-password-error');
  const frmResetPasswordErrors = frmResetPasswordErrorWrapper.find('.errors');
  const btnResetPassword = frmResetPassword.find('button');
  const btnResetPasswordText = btnResetPassword.text();
  let currentResetPasswordRequest = null;

  // define from validator
  frmResetPassword.validate({
    rules: {
      new_password: {
        required: true,
        pwcheck: true,
        minlength: 6,
      },
      verifycode: "required"
    },
    messages: {
      new_password: {
        pwcheck: "Password must at least 6 characters and contain number(s), lower case character(s), upper case character(s) and special character(s)."
      }
    }
  });

  frmGetOtc.on("submit", function (e) {
    e.preventDefault();
    frmGetOtcErrorWrapper.hide();
    frmGetOtcErrors.html("");

    // check form is valid
    if (!frmGetOtc.valid()) {
      return;
    }

    const email = frmGetOtc.find('input#RecoverEmail').val();
    const postData = {"email": email};

    currentGetOtcRequest = $.ajax({
      type: frmGetOtc.attr('method'),
      url: appUrl + '/customer/onetime-password',
      data: JSON.stringify(postData),
      contentType: "application/json; charset=utf-8",
      beforeSend: function () {
        if (currentGetOtcRequest != null) {
          currentGetOtcRequest.abort();
        }

        btnGetOtc.attr('disabled', true);
        btnGetOtc.text('Getting One-time Password ...');
      },
      success: function (res) {
        frmGetOtcErrors.removeClass("warning");
        if (res.success) {
          // shopifyLogin(frmGetOtc);
          // console.log("get success.")
          frmGetOtcWrapper.addClass("hide");
          frmLoginWrapper.removeClass("hide");
          // frmResetPassword.show();
          resetPassSuccessMess.show();
          location.href = "/account/login#login";
        } else {
          let errorsHtml = '<ul>' +
            ' <li>' + res.message + '</li>' +
            '</ul>';
          
          if (res.warning === true) {
            frmGetOtcErrors.addClass("warning");
            errorsHtml = '<ul class="warning">' +
              ' <li>' + res.message + '</li>' +
              '</ul>';
          }

          frmGetOtcErrors.html(errorsHtml);
          frmGetOtcErrorWrapper.show();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        const res = xhr.responseJSON;
        let errorsHtml = '<ul>' +
          ' <li>' + res.message + '</li>' +
          '</ul>';

        if (typeof res.warning !== "undefined" && res.warning === true) {
          frmGetOtcErrors.addClass("warning");
          errorsHtml = '<ul class="warning">' +
            ' <li>' + res.message + '</li>' +
            '</ul>';
        }

        frmGetOtcErrors.html(errorsHtml);
        frmGetOtcErrorWrapper.show();
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      },
      complete: function (res) {
        btnGetOtc.text(btnGetOtcText);
        btnGetOtc.removeAttr('disabled');
      }
    });
  });

  frmResetPassword.on("submit", function (e) {
    e.preventDefault();
    frmGetOtcErrorWrapper.hide();
    frmGetOtcErrors.html("");
    frmResetPasswordErrorWrapper.hide();
    frmResetPasswordErrors.html("");

    // check form is valid
    if (!frmGetOtc.valid()) {
      return;
    }

    const email = frmGetOtc.find('input#RecoverEmail').val();
    const verifycode = frmResetPassword.find('input#verifycode').val();
    const newPassword = frmResetPassword.find('input#new_password').val();
    const postData = {
      "email": email,
      "verifycode": verifycode,
      "new_password": newPassword
    };

    currentResetPasswordRequest = $.ajax({
      type: frmResetPassword.attr('method'),
      url: appUrl + '/customer/reset-password',
      data: JSON.stringify(postData),
      contentType: "application/json; charset=utf-8",
      beforeSend: function () {
        if (currentResetPasswordRequest != null) {
          currentResetPasswordRequest.abort();
        }

        btnResetPassword.attr('disabled', true);
        btnResetPassword.text('Processing ...');
      },
      success: function (res) {
        console.log(res);
        if (res.success) {
          $('.cancel-reset')[0].click();
          resetPassSuccessMess.show();
        } else {
          const errorsHtml = '<ul>' +
            ' <li>' + res.message + '</li>' +
            '</ul>';

          frmResetPasswordErrors.html(errorsHtml);
          frmResetPasswordErrorWrapper.show();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        const res = xhr.responseJSON;
        const errorsHtml = '<ul>' +
          ' <li>' + res.message + '</li>' +
          '</ul>';

        frmResetPasswordErrors.html(errorsHtml);
        frmResetPasswordErrorWrapper.show();
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      },
      complete: function (res) {
        btnResetPassword.text(btnResetPasswordText);
        btnResetPassword.removeAttr('disabled');
      }
    });
  });

  $('.cancel-reset').on("click", function (e) {
    frmGetOtc.show();
    frmGetOtc[0].reset();
    frmGetOtcErrorWrapper.hide();
    frmGetOtcErrors.html("");

    frmResetPassword.hide();
    frmResetPassword[0].reset();
    frmResetPasswordErrorWrapper.hide();
    frmResetPasswordErrors.html("");
  });

  $('a[href$="#recover"]').click(function (e) {
    resetPassSuccessMess.hide();
  });

  $.validator.addMethod("pwcheck", function (value) {
    return /[0-9]+/.test(value) // has a lowercase letter
      && /[a-z]+/.test(value) // has a lowercase letter
      && /[A-Z]+/.test(value) // has a lowercase letter
      && /[^a-zA-Z0-9]+/.test(value) // has a lowercase letter
  });
});
